export function compareOnlyNumericCharacters(
  valueA: string | null | undefined,
  valueB: string | null | undefined,
) {
  const valA = String(valueA ?? "");
  const valB = String(valueB ?? "");

  // strip non numeric characters
  const valueAIntegers = valA.replace(/\D/g, "");
  const valueBIntegers = valB.replace(/\D/g, "");

  // sort naturally
  return valueAIntegers.localeCompare(valueBIntegers, "en", { numeric: true });
}
